import { render, staticRenderFns } from "./LevelFormulae.vue?vue&type=template&id=d810fa30&scoped=true&"
import script from "./LevelFormulae.vue?vue&type=script&lang=js&"
export * from "./LevelFormulae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d810fa30",
  null
  
)

export default component.exports